import { CloudRain, Umbrella } from "lucide-react";

const LEVEL = {
  heavy: { label: "Heavy rain", cls: "bg-blue-700 text-white", advice: "Delay sowing and spraying — seeds may wash out and sprays will not stick." },
  moderate: { label: "Rain likely", cls: "bg-blue-100 text-blue-800", advice: "Spray early in a dry gap; sowing is fine if drainage is good." },
};

export function RainAlerts({ alerts, onPick }) {
  const active = alerts.filter((a) => a.level !== "none").sort((a, b) => b.total_mm - a.total_mm);
  if (!alerts.length) return null;
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-4" data-testid="rain-alerts">
      <div className="text-xs uppercase tracking-wider text-stone-500 font-semibold mb-2 flex items-center gap-1"><CloudRain className="h-3.5 w-3.5 text-blue-600" /> Rain in the next 3 days</div>
      {active.length === 0 ? (
        <p className="text-sm text-stone-500 flex items-center gap-2" data-testid="rain-alerts-clear"><Umbrella className="h-4 w-4 text-[#2D6A4F]" /> No heavy rain expected at any of your fields — good days to sow and spray.</p>
      ) : (
        <ul className="space-y-2">
          {active.map((a) => (
            <li key={a.field_id}>
              <button data-testid={`rain-alert-${a.field_id}`} onClick={() => onPick(a.field_id)} className="w-full text-left rounded-xl border border-blue-100 bg-blue-50/60 hover:bg-blue-50 px-3 py-2.5 transition-colors">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-emerald-950 truncate">{a.name}</span>
                  <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full shrink-0 ${LEVEL[a.level].cls}`}>{LEVEL[a.level].label}</span>
                </div>
                <div className="text-xs text-stone-600 mt-1 font-mono-tech">{a.total_mm} mm total · peak {a.peak_day} {a.peak_mm} mm</div>
                <div className="text-xs text-blue-900 mt-1">{LEVEL[a.level].advice}</div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function RainBanner({ rain }) {
  if (!rain || rain.level === "none") return null;
  const l = LEVEL[rain.level];
  return (
    <div data-testid="pin-rain-banner" className={`rounded-xl px-4 py-3 flex gap-3 ${rain.level === "heavy" ? "bg-blue-700 text-white" : "bg-blue-50 text-blue-900 border border-blue-100"}`}>
      <CloudRain className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="text-sm">
        <div className="font-semibold">{l.label}: {rain.total_mm} mm over 3 days, heaviest {rain.peak_day} ({rain.peak_mm} mm)</div>
        <div className={`text-xs mt-0.5 ${rain.level === "heavy" ? "opacity-90" : ""}`}>{l.advice}</div>
      </div>
    </div>
  );
}
